// extracted by mini-css-extract-plugin
export default {"Ondemand":"style_Ondemand__sCIjv","hr":"style_hr__hPsSU"};